import React from "react";
import Separator from "../../components/Separator";
import CircularProgress from "@material-ui/core/CircularProgress";

const LoadingValidateAuth = () => {
  return (
    <React.Fragment>
      <div
        style={{
          position: "relative",
          height: "100vh",
          paddingLeft: "28px",
          paddingRight: "28px",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Separator variant="Horizontal" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                {/* <div>
                  <img src={Logo} alt="logo" style={{ width: "124px" }} />
                </div> */}
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <CircularProgress size={18} />
                  <Separator variant="Horizontal" size={5} />
                  <small>Please wait while we validate your authentication</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoadingValidateAuth;
